export default __webpack_public_path__ + "static/media/n3.06a40b77.jpg";